export function supplyEventInAction(node){
  if(
    node.actions &&
    !node.actions.includes('event')
  ){
    node.actions.push('event')
  }
}
